import { jsx } from '@emotion/react/jsx-runtime';
import { createPolymorphicComponent, useSlot } from '@nettbureau/core';
import { useCss } from '@nettbureau/styling';
import { useCardContext } from './card-context.js';

/**
 * Card footers arranges footer elements, often buttons, at the bottom of the card.
 */ const CardFooter = createPolymorphicComponent((props, ref)=>{
    const cardContext = useCardContext();
    const [mergedProps, mergedRef] = useSlot('CardFooter', props, ref);
    const { as: Component = 'div', children, className, css, layout, padding = cardContext?.padding } = mergedProps;
    const cardFooterCss = useCss(({ mixins })=>[
            mixins.flex({
                align: 'center',
                ...layout
            }),
            padding && mixins.spacing({
                padding
            })
        ]);
    return /*#__PURE__*/ jsx(Component, {
        "data-card-header": true,
        ref: mergedRef,
        className: className,
        css: [
            cardFooterCss,
            css
        ],
        children: children
    });
});

export { CardFooter };
//# sourceMappingURL=card-footer.js.map
